import { productStyles } from '@/features/pos/components/ProductCatalog/parts/ProductList/styles'
import { Mode } from '@/features/pos/components/ProductCatalog/parts/ProductList/types'
import { getItemSpacingMargins } from '@/features/pos/components/ProductCatalog/parts/ProductList/utils'
import { useMemo } from 'react'
import { ViewStyle } from 'react-native'

export const useItemStylesByColumn = (numColumns: number, mode: Mode): ViewStyle[][] => {
    return useMemo(() => {
        return Array.from({ length: numColumns }, (_, index) => [
            productStyles.product,
            ...(mode === 'grid' ? [getItemSpacingMargins(index, numColumns)] : []),
        ])
    }, [numColumns, mode])
}
